import {get, put} from './http';

// The fixed eight-colour flag palette, mirroring FlagColors server-side. Order is display order.
// Flags live on items only (see ItemFlag server-side); a submission shows its item's flag.
export const FLAG_COLORS = [
  'red',
  'orange',
  'yellow',
  'green',
  'teal',
  'blue',
  'purple',
  'pink'
] as const;

export type FlagColor = (typeof FLAG_COLORS)[number];

export type FlagLabel = {color: FlagColor; label: string};

// ItemFlagsController limits: SetFlagNoteRequest.MaxLength and FlagLabelDto.MaxLength.
export const FLAG_NOTE_MAX_LENGTH = 1000;
export const FLAG_LABEL_MAX_LENGTH = 40;

export const flagLabelsApi = {
  list: async () => get<FlagLabel[]>('/me/flag-labels'),
  // Replaces the caller's whole set; a colour left out reverts to its default name.
  replace: async (labels: FlagLabel[]) => put<{labels: FlagLabel[]}>('/me/flag-labels', {labels})
};
